import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { FluidsBolusAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-fluids-bolus-slot',
    templateUrl: './fluids-bolus-slot.component.html',
    styleUrl: './fluids-bolus-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsBolusSlotComponent implements SheetSlotComponentBase {

	action!: FluidsBolusAction;
	value!: string | null;

	@Input('action') set updateAction(action: FluidsBolusAction | null) {
		this.action = action as FluidsBolusAction;
		this.value = this.action.amountGiven?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}